import {BaseTerms} from "../../infrastructure/models/base-terms";

export class PreviousMeetingsWidgetTerms extends BaseTerms {
  GAME_CENTER_PREVIOUS_MEETINGS = "Previous Meetings";
  H2H_EMPTY_PREVIOUS_MEETINGS = "We have no data on previous meetings between these teams";
  H2H_EMPTY_PREVIOUS_MEETINGS_SPORTID_3 = "We currently don't have data on any previous matchups between these players";
  H2H_WINS = "Wins";
  H2H_DRAWS = "Draws";
}
